import HeaderNotification from "../Header/Header.Notification";
import HeaderLanguageSwitcher from "../Header/Header.LanguageSwitcher";
import HeaderMenu from "../Header/Header.Menu";
import HeaderWidget from "../../Molecule/HeaderWidget/HeaderWidget";

export default class HeaderWithHorizontalMenu {
	static init() {
        const headerElement = document.querySelector('.header-with-horizontal-menu');

        if (!headerElement) {
            return;
        }

        new HeaderWithHorizontalMenu(headerElement);
		HeaderNotification.init();
		HeaderLanguageSwitcher.init();
		HeaderMenu.init();

        HeaderWidget.init();
    }

    constructor(element) {
		if (!element) {
			return;
		}

		const endVal = "top+=220";
		const endValMob = "top+=40";

        // Navigation, see also Header.Menu.js
        let header = document.querySelector('#header');
        function HeaderHeight() {
            let headerHeight = header ? header.getBoundingClientRect().height : 0;
            let pageBanner = document.querySelector('.page-banner');
            if (pageBanner) {
                pageBanner.style.paddingTop = headerHeight + 'px';
            }
        }

		// header-main Trigger
		const headerTrigger = (passHeight, passEnd) => {
			gsap.to($('.header-main'), {
				height: passHeight,
				ease: "none",
				backgroundColor: "rgba(255,255,255,1)",
				boxShadow: '0 0 0 2px #F3F4F6',
				immediateRender: false,
				scrollTrigger: {
					trigger: 'body',
					start: "top top",
					end: passEnd,
					scrub: true,
					toggleActions: "reset none none none",
					markers: false,
				}
			})
                // update the header height on scroll
                .eventCallback('onUpdate', () => { requestAnimationFrame(HeaderHeight) });
		};

		// menu trigger
		const menuTrigger = (passHeight, passEnd) => {
			gsap.to($('.header-with-horizontal-menu--with-white-menu'), {
				ease: "none",
				color: '#374151',
				immediateRender: false,
				scrollTrigger: {
					trigger: 'body',
					start: "top top",
					end: passEnd,
					scrub: true,
					toggleActions: "reset none none none",
					markers: false,
				}
			});
		};

		// Logo Trigger
		const logoTrigger = (passWidth, passEnd) => {
			gsap.to($('#logo'), {
				width: passWidth,
				ease: 'none',
				scrollTrigger: {
					start: "top top",
					end: passEnd,
					scrub: true,
					toggleActions: "reset none none none",
				}
			});
		};

		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 1200px)": function () {
                if ($('.header-main').length) headerTrigger(104, endVal);
				if ($('.header-with-horizontal-menu--with-white-menu').length) menuTrigger(104, endVal);
                if ($('#logo').length) logoTrigger(99, endVal);
			},

			// medium
			"(min-width: 992px) and (max-width: 1199px)": function () {
                if ($('.header-main').length) {
                    gsap.set(".header-main", {height: 120});
                    headerTrigger(104, endVal);
                    gsap.set(".header-main", {height: 120});
                }
                if ($('.header-with-horizontal-menu--with-white-menu').length) {
                    menuTrigger(104, endVal);
                    gsap.set(".header-with-horizontal-menu--with-white-menu", {color: '#fff'});
                }
                if ($('#logo').length) {
                    gsap.set("#logo", {width: 106});
                    logoTrigger(91, endVal);
                }
			},

			// Tablet & Mobile 0 to 991
			"(max-width: 991px)": function () {
                if ($('.header-main').length) {
                    gsap.set(".header-main", {height: 96});
                    headerTrigger(80, endValMob);
                }
                if ($('.header-with-horizontal-menu--with-white-menu').length) {
                    gsap.set(".header--with-white-menu", {color: '#fff'});
                    menuTrigger(104, endValMob);
                }
                if ($('#logo').length) {
                    gsap.set("#logo", {width: 91});
                    logoTrigger(80, endValMob);
                }
			}
		});
	}
}
